import { Tabs, Tab, Box, Typography } from '@mui/material';
import React from 'react';

// Import types
import type { MarketplaceService } from '../../types/pricing';

interface TermTabsProps {
  service: MarketplaceService;
  selectedTerm: number | null;
  onTermChange: (term: number) => void;
}

/**
 * TermTabs Component
 * Displays contract term tabs for service detail pages
 * Shows tabs for multiple terms, or term indicator for single term
 */
export const TermTabs: React.FC<TermTabsProps> = ({
  service,
  selectedTerm,
  onTermChange
}) => {

  // Don't show anything if service has no contract terms
  if (!service.contract_term_months || service.contract_term_months.length === 0) {
    console.log('❌ TermTabs: No contract terms, returning null');
    return null;
  }

  // Show tabs if service has multiple contract terms
  if (service.contract_term_months.length > 1) {
    return (
      <Box sx={{ mb: 3 }}>
        <Tabs
          value={selectedTerm !== null && selectedTerm !== undefined ? selectedTerm : (service.default_term_months || service.contract_term_months[0])}
          onChange={(e, newValue) => onTermChange(newValue)}
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          {service.contract_term_months.map(term => (
            <Tab
              key={term}
              label={`${term} Months`}
              value={term}
              sx={{ minWidth: 120 }}
            />
          ))}
        </Tabs>
      </Box>
    );
  }

  // For single-term services, show a term indicator
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="body2" color="text.secondary">
        {service.contract_term_months[0]}-month contract term
      </Typography>
    </Box>
  );
};